import React, { useState } from "react";
import { Collapse, Box, Button } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

export const ReadMoreDrawer = ({ children, childrenHeight }) => {
  const [isCollapse, setIsCollapse] = useState(false);
  const LIMIT_HEIGHT = 480;

  return (
    <Box>
      {childrenHeight > LIMIT_HEIGHT && (
        <>
          <Collapse in={isCollapse} orientation="horizontal" collapsedSize={LIMIT_HEIGHT}>
            {children}
          </Collapse>
          <Button
            onClick={() => {
              setIsCollapse(!isCollapse);
            }}
          >
            En savoir plus {isCollapse ? <ExpandLess /> : <ExpandMore />}
          </Button>
        </>
      )}
      {childrenHeight < LIMIT_HEIGHT && <>{children}</>}
    </Box>
  );
};
